import request from '../../request';

export default {
  state: {
    filters: {
      name: '',
      promoter: '',
    },
    activities: [],
    filteredActivities: [],
  },
  mutations: {

    setFilter(state, payload) {
      Object.assign(state.filters, { [payload.filter]: payload.val });
    },
    setActivities(state, payload) {
      Object.assign(state, { activities: payload });
      Object.assign(state, { filteredActivities: payload });
    },
    setPromoters(state, payload) {
      Object.assign(state, { promoters: payload });
    },
    setFilteredActivities(state, newActivities) {
      Object.assign(state, { filteredActivities: newActivities });
    },
  },
  actions: {
    adminGetActivities(context) {
     // http://localhost:8000/api/activity?promoter=2&withDrafts=true&unapproved=true
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}activity`,
        data: {
          withDrafts: true,
          unapproved: true,
        },
      }, (err, res) => {
        if (res.status === 200) {
          if (typeof res.body.data !== 'undefined') {
            context.commit('setActivities', res.body.data);
          }
        }
      });
    },
    adminActivititesSetApproved(context, payload) {
      request.make({
        type: 'PATCH',
        url: `${process.env.API_URL}activity`,
        data: payload,
      }, (err, res) => {
        if (res.status === 204) {
          context.dispatch('adminGetActivities');
          // context.commit('setActivityApproved', res.body.data);
        }
      });
    },
    adminActivititesSetHighlight(context, payload) {
      request.make({
        type: 'PATCH',
        url: `${process.env.API_URL}activity`,
        data: payload,
      }, (err, res) => {
        if (res.status === 204) {
          context.dispatch('adminGetActivities');
        }
      });
    },
    adminActivitiesSetNameFilter(context, payload) {
      context.commit('setFilter', { filter: 'name', val: payload });
      context.dispatch('applyFilters');
    },
    adminActivitiesSetPromoterFilter(context, payload) {
      context.commit('setFilter', { filter: 'promoter', val: payload });

      context.dispatch('applyFilters');
    },
    applyFilters(context) {
      let newActivities = context.state.activities;
      if (context.state.filters.name !== '') {
        newActivities = newActivities.filter(activity =>
        activity.translations[context.rootState.language].name.toLowerCase()
        .indexOf(context.state.filters.name.toLowerCase()) !== -1,
        );
      }
      if (context.state.filters.promoter !== '') {
        newActivities = newActivities.filter(activity =>
        activity.promoter.data.company_name.toLowerCase()
        .indexOf(context.state.filters.promoter.toLowerCase()) !== -1,
        );
      }
      context.commit('setFilteredActivities', newActivities);
    },
  },
  getters: {
  },
};



// WEBPACK FOOTER //
// ./src/store/admin/activities.js